"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _EmbedOnlyModal = _interopRequireDefault(require("../Modal/EmbedOnlyModal"));
var _PlayButton = _interopRequireDefault(require("./PlayButton"));
var _YoutubeVideo = _interopRequireWildcard(require("./YoutubeVideo"));
const _excluded = ["placeholder", "src", "title", "renderPlaceholder", "videoId"]; // TODO: enable other kinds of videos, not just YouTube
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StyledEmbedOnlyModal = (0, _styledComponents.default)(_EmbedOnlyModal.default)`
  /* shouldn't need this, but some weird ish is going on in prod */
  /* building prod locally, close button doesn't work. preview on vercel it works, but gets tiny */
  width: 90vw;
  max-width: 1120px;

  ${_YoutubeVideo.VideoWrapper} {
    width: 90vw;
    max-width: 1120px;
  }
`;
const VideoPlaceholder = _styledComponents.default.img`
  cursor: pointer;
  display: block;
  width: 100%;
  max-width: 100%;
`;
const VideoContainer = _styledComponents.default.div`
  position: relative;
`;

// TODO: if click escape from INSIDE iframe, exit out
const VideoModal = _ref => {
  let {
      placeholder,
      renderPlaceholder,
      videoId
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
  const [player, setPlayer] = (0, _react.useState)(null);
  const handleChangeVisible = visible => {
    if (player) {
      if (isModalOpen) player.pauseVideo();else player.playVideo();
    }
    setIsModalOpen(visible);
  };
  const handleYTReady = event => {
    setPlayer(event.target);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderPlaceholder ? renderPlaceholder({
    onClick: () => handleChangeVisible(true)
  }) : /*#__PURE__*/_react.default.createElement(VideoContainer, (0, _extends2.default)({}, others, {
    onClick: () => handleChangeVisible(true)
  }), /*#__PURE__*/_react.default.createElement(VideoPlaceholder, {
    src: placeholder,
    alt: "Video"
  }), /*#__PURE__*/_react.default.createElement(_PlayButton.default, null)), /*#__PURE__*/_react.default.createElement(StyledEmbedOnlyModal, {
    visible: isModalOpen,
    isClosable: true,
    onChangeVisible: handleChangeVisible
  }, /*#__PURE__*/_react.default.createElement(_YoutubeVideo.default, {
    onReady: handleYTReady,
    videoId: videoId
  })));
};
VideoModal.defaultProps = {
  videoId: 'L_ba5EnJkCc'
};
VideoModal.propTypes = {
  placeholder: PropTypes.string,
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  renderPlaceholder: PropTypes.func,
  videoId: PropTypes.string.isRequired
};
var _default = exports.default = VideoModal;